import React from 'react';

const WhyChooseOne = () => {
  return (
    <section className="why-choose-one">
      <div className="container">
        <div className="row">
          <div className="col-xl-5 col-lg-6">
            <div className="why-choose-one__left">
              <div className="section-title text-left">
                <div className="section-title__tagline-box">
                  <span className="section-title__tagline">How We Thrive Together</span>
                  <div className="section-title-shape">
                    <img src="assets/images/shapes/section-title-shape.png" alt="decorative shape" />
                  </div>
                </div>
                <h2 className="section-title__title">Our Guiding Principles</h2>
              </div>
              <p className="why-choose-one__text">These principles are the foundation of our community, fostering a culture of collaboration, growth, and mutual respect.</p>
            </div>
          </div>
          <div className="col-xl-7 col-lg-6">
            <div className="why-choose-one__right">
              <div className="why-choose-one__points-box">
                <div className="why-choose-one__points-img">
                  <img src="https://images.pexels.com/photos/33476178/pexels-photo-33476178.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" style={{ width: 'auto', height: '500px', objectFit: 'cover', display: 'block' }} alt="A team putting their hands together in a circle." />
                </div>
                <div className="why-choose-one__points-content">
                  <ul className="list-unstyled why-choose-one__points">
                    <li>
                      <div className="icon">
                        <span className="icon-tick"></span>
                      </div>
                      <div className="text">
                        <p>Everyone has something to offer and something to learn.</p>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <span className="icon-tick"></span>
                      </div>
                      <div className="text">
                        <p>Ideas are more powerful when shared and executed together.</p>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <span className="icon-tick"></span>
                      </div>
                      <div className="text">
                        <p>Mentorship is a cycle; today’s learners are tomorrow’s leaders.</p>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <span className="icon-tick"></span>
                      </div>
                      <div className="text">
                        <p>Creativity is a force for change—social, cultural, and economic.</p>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <span className="icon-tick"></span>
                      </div>
                      <div className="text">
                        <p>The creative journey is not a competition; it’s a community.</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseOne;
